export type WalletSummary = {
  balanceCents: number;
  /** Real money that may be withdrawn now; seeded funds are spendable but never withdrawable. Absent on an older API. */
  withdrawableCents?: number;
  /** Max Bucks (pack-only, never withdrawable) in cents. 0 on an older API. */
  maxBucksCents: number;
  frozen: boolean;
};

export function parseWalletSummary(data: unknown): WalletSummary | null {
  if (!data || typeof data !== "object") return null;
  const row = data as Record<string, unknown>;
  if (typeof row.balanceCents !== "number" || !Number.isFinite(row.balanceCents)) {
    return null;
  }
  return {
    balanceCents: row.balanceCents,
    withdrawableCents: typeof row.withdrawableCents === "number" && Number.isFinite(row.withdrawableCents)
      ? row.withdrawableCents
      : undefined,
    maxBucksCents: typeof row.maxBucksCents === "number" && Number.isFinite(row.maxBucksCents)
      ? Math.max(0, row.maxBucksCents)
      : 0,
    frozen: row.frozen === true,
  };
}

/** Parsed summary is source of truth; a failed/invalid GET must not unfreeze a known freeze. */
export function resolveWalletFrozen(args: {
  previouslyFrozen: boolean;
  summary: WalletSummary | null;
}): boolean {
  if (args.summary) return args.summary.frozen;
  return args.previouslyFrozen;
}

export function frozenAfterWriteRejection(
  errorCode: string | undefined,
  previouslyFrozen: boolean,
): boolean {
  return errorCode === "WALLET_FROZEN" || previouslyFrozen;
}

export type WalletRefreshGate = { latest: number };

export function beginWalletRefresh(gate: WalletRefreshGate): number {
  gate.latest += 1;
  return gate.latest;
}

export function isCurrentWalletRefresh(gate: WalletRefreshGate, requestGen: number): boolean {
  return requestGen === gate.latest;
}
